import React, { Component } from "react";
import styled from "styled-components";
import Divider from '@material-ui/core/Divider';

const StyledRow = styled.div`
  && {
    height: 70px;
    font-style: normal;
    padding-right: 24px;
    padding-left: 24px;

    .metric-title {
      font-family: "Work Sans";
      font-size: 12px;
      font-weight: 600;
      text-align: left;
      float: left;
      color: #5F6368;
      line-height: 70px;
    }

    .metric-value {
      font-family: "Space Mono";
      font-size: 20px;
      font-weight: 400;
      text-align: right;
      float:right;
      line-height: 70px;
    }
  }
`;

const ColumnMetricTitle = styled.div`
  && {
    font-family: "Work Sans";
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    float: left;
    color: #5F6368;
    line-height: 70px;
    text-align: center;
    float: none;
    line-height: 14px;
  }
`;

const DisplayColumn = styled.div`
&& {
    width:161px;
    height:145px;
    border-right: #DADCE0 solid 1px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;  
    line-height: 35px;
}`;

const DisplayColumnMetric = styled.span`
&& {
    font-family: "Space Mono";
    font-size: 20px;
    font-weight: 400;
    text-align: center;
}`;

const DisplayPill = styled(DisplayColumnMetric)`
&& {
    font-size: 14px;
    font-weight: 700;
    word-spacing: -5px;
    background-color: #DADCE0;
    border-radius: 4px;
    padding-right: 0.2em;
    padding-left: 0.2em;
}`;

export class LoanBodySummary extends Component {

  renderColumns = () => {
    const { metrics,data } = this.props;
    return (
      <div style={{ display: "table" }}>
        <DisplayColumn>
          <DisplayColumnMetric>{!metrics[2] ? "" : metrics[2].metricValue}</DisplayColumnMetric>
          <ColumnMetricTitle>{!metrics[2] ? "" : metrics[2].label}</ColumnMetricTitle>
        </DisplayColumn>
        <DisplayColumn>
          <DisplayPill>{!metrics[3] ? "" : metrics[3].metricValue}</DisplayPill>
          <ColumnMetricTitle>{!metrics[3] ? "" : metrics[3].label}</ColumnMetricTitle>
        </DisplayColumn>
        <DisplayColumn>
          <DisplayColumnMetric>{!metrics[4] ? "" : metrics[4].metricValue}</DisplayColumnMetric>
          <ColumnMetricTitle>{!metrics[4] ? "" : metrics[4].label}</ColumnMetricTitle>
        </DisplayColumn>
        <DisplayColumn style={{ border: "none" }}>
          <DisplayColumnMetric>{!metrics[5] || data.details && data.details.index && data.details.index.id==="2a7680cd-467f-11e9-82f6-0242ac120002"  ? "--" : metrics[5].metricValue}</DisplayColumnMetric>
          <ColumnMetricTitle>{!metrics[5] ? "" : metrics[5].label}</ColumnMetricTitle>
        </DisplayColumn>
      </div>
    )
  }

  render() {
    const { metrics, data } = this.props;

    return (
      <div>
        <StyledRow>
          <div className="metric-title">{!metrics[0] ? "" : metrics[0].label}</div>
          <div className="metric-value" style={{ fontSize: 24 }}>{!metrics[0] ? "" : metrics[0].metricValue}</div>
        </StyledRow>
        <Divider />
        <StyledRow>
          <div className="metric-title">{!metrics[1] ? "" : metrics[1].label}</div>
          <div className="metric-value">{!metrics[1] ? "" : metrics[1].metricValue}</div>
        </StyledRow>
        <Divider />
        {this.renderColumns()}
      </div>
    )
  }
}